import api from '../api';

const calendarService = {
    /**
     * Fetch all meetings for a given month.
     * @param {string} month - Format: "YYYY-MM"
     * @param {AbortSignal} [signal] - Optional AbortController signal to cancel the request
     * @returns Promise<{ meetings: { [date: string]: Meeting[] } }>
     */
    getMonthMeetings: async (month, signal) => {
        // Parse month to get start and end dates
        const [year, monthNum] = month.split('-');
        const startDate = new Date(year, parseInt(monthNum) - 1, 1);
        const endDate = new Date(year, parseInt(monthNum), 0);

        const toIsoDate = (date) => date.toISOString().split('T')[0];

        const response = await api.get('/meetings', {
            params: {
                start: toIsoDate(startDate),
                end: toIsoDate(endDate),
            },
            signal,
        });

        // Group meetings by date
        if (response.status && response.data?.meetings) {
            const groupedMeetings = {};
            const meetingsArray = Array.isArray(response.data.meetings) ? response.data.meetings : [];

            meetingsArray.forEach(meeting => {
                const meetingDate = new Date(meeting.start_at).toISOString().split('T')[0];
                if (!groupedMeetings[meetingDate]) {
                    groupedMeetings[meetingDate] = [];
                }
                groupedMeetings[meetingDate].push(meeting);
            });

            return {
                ...response,
                data: {
                    ...response.data,
                    meetings: groupedMeetings,
                },
            };
        }

        return response;
    },
};

export default calendarService;
